export const findPageByCmsId = (cmsId, data) => {
    if (!data)
        return;
    const { businesses, pages } = data;
    const business = businesses.find((business) => business.cms.find((cms) => cms.id === cmsId));
    if (!business)
        return;
    const cms = business.cms.find((cms) => cms.id === cmsId);
    if (!cms)
        return;
    const page = pages.find((page) => page.id === cms.merchantPageId);
    return page;
};
